import { FilterArrayType } from 'common/components/Filters';

export const toFilterVariableExport = (filterList: FilterArrayType[]) => {
  const keyMapping: { [key: string]: string } = {
    businessUnitId: 'filterBusinessUnitId',
    currencyId: 'filterCurrencyId',
    departmentId: 'filterDepartmentId',
    _taStatusTypeId: 'filterStatusTypeId',
    travelAuthorizationId: 'filterTaId',
    travelerId: 'filterTravelerId',
    _travelPolicyId: 'filterTravelPolicyId',
    corporateWorkgroupId: 'filterWorkgroupId',
    _isCorporateTravelAuthorization: 'isFilterCorporateTravel',
    _isOverBudget: 'isFilterOverBudget',
    isLinkSearch: 'isLinkSearch',
  };

  const filterVariablesList = filterList.reduce((acc, { filterKey, value }) => {
    const newKey = keyMapping[filterKey];
    if (newKey) {
      acc[newKey] = value;
    }
    return acc;
  }, {} as { [key: string]: string | number | boolean | any[] });

  return filterVariablesList;
};
